module.exports = __webpack_public_path__ + "static/media/whatsapp-logo.a7b365a2.png";